import get from 'lodash/get';
import type {Thesaurus, ThesaurusNode} from '../types';
import {getNodesAndAncestors} from './getNodesAndAncestors';

export const findNodePath = (
  codeOrId: string,
  thesaurus: Thesaurus,
): string[] | undefined => {
  const nodesWithAncestors = getNodesAndAncestors([codeOrId], thesaurus);

  if (!nodesWithAncestors || nodesWithAncestors.length === 0) {
    return undefined;
  }

  const nodeWithAncestors = nodesWithAncestors[0];
  if (
    !nodeWithAncestors ||
    // Check if dummy was returned
    nodeWithAncestors.ancestors[0].label === `missing_${codeOrId}`
  ) {
    return undefined;
  }

  const ancestorIds = nodeWithAncestors.ancestors.map(a => a.id);
  // Remove root node id
  ancestorIds.shift();

  // Add node id, so also get node index.
  ancestorIds.push(nodeWithAncestors.node.id);

  const pathIndexes: Array<string> = [];
  ancestorIds.forEach(id => {
    if (pathIndexes.length === 0) {
      const nodeIndex = thesaurus.children?.findIndex(c => c.id === id);
      if (nodeIndex !== undefined && nodeIndex >= 0) {
        pathIndexes.push('children');
        pathIndexes.push(nodeIndex.toString());
      }
    } else {
      const thesaurusChildren = get(
        thesaurus,
        [...pathIndexes, 'children'],
        undefined,
      );
      if (thesaurusChildren) {
        const nodeIndex = (thesaurusChildren as ThesaurusNode[]).findIndex(
          c => c.id === id,
        );
        if (nodeIndex !== undefined && nodeIndex >= 0) {
          pathIndexes.push('children');
          pathIndexes.push(nodeIndex.toString());
        }
      }
    }
  });

  return pathIndexes;
};
